import { FiverButton, ThemeSwitcher } from "@components"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import { useState } from "react"
export const MobileHeader = () => {
  const [width, setWidth] = useState("0%")

  //   menu open toggler for mobile menu
  const MobileMenuHandler = () => {
    if (width === "0%") {
      setWidth("100%")
    } else {
      setWidth("0%")
    }
  }
  return (
    <div>
      {/* <!-- ==================== mobile-menu =============== --> */}

      {/* <!-- Mobile menu button--> */}
      <div className="py-3 flex justify-between items-center xl:hidden">
        {/* <!-- Mobile menu button--> */}
        <div>
          <div>
            <li className="flex text-black items-center">
              <a href="/">
                <StaticImage
                  src="../../images/visualfolio-logo.png"
                  alt="visual-folio-logo"
                  width={90}
                  height={40}
                  placeholder="blurred"
                />
              </a>
            </li>
          </div>
        </div>
        <div className="flex gap-3 items-center">
          <FiverButton />
          <ThemeSwitcher />
          <button
            onClick={() => MobileMenuHandler()}
            type="button"
            className="inline-flex items-center justify-center rounded-md p-2 text-black bg-btn bg-glass  hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
          >
            <svg
              className="block h-4 text-black bg-putple-600 w-3"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </button>
        </div>
      </div>
      {/* <!-- Mobile menu, show/hide based on menu state. --> */}
      <div className="">
        <div
          className={`text-center mt-4 overlay`}
          style={{ width: `${width}` }}
        >
          <a
            onClick={() => MobileMenuHandler()}
            className="closebtn text-6xl absolute top-4 right-4 mr-3 font-semibold text-black"
          >
            &times;
          </a>
          <div className="space-y-1 mt-16 px-2 pt-2 pb-3">
            <Link
              to="/daily-feed"
              rel="canonical"
              className="text-black block px-3 py-2 rounded-md text-base font-medium"
            >
              Daily Feed
            </Link>
            <Link
              to="/our-client-reviews"
              className="text-black block px-3 py-2 rounded-md text-base font-medium"
              aria-current="page"
              rel="canonical"
            >
              Our Client Reviews
            </Link>
            <Link
              to="/resource"
              rel="canonical"
              className="text-black block px-3 py-2 rounded-md text-base font-medium"
            >
              Resources Plan
            </Link>
            <Link
              to="/custom-quote"
              rel="canonical"
              className="text-black block px-3 py-2 rounded-md text-base font-medium"
            >
              Custom Quote
            </Link>
            <Link
              to="/real-time-quote"
              rel="canonical"
              className="text-black block px-3 py-2 rounded-md text-base font-medium"
            >
              Real Time Quote
            </Link>

            <Link
              to="/book-consultancy"
              rel="canonical"
              className="text-black block px-3 py-2 rounded-md text-base font-medium"
            >
              Book Free Consultancy
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
